import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //decorate requests with user token
    // if (req.url.includes("monitoreo-web-api")) {
    //   req.headers.append('Authorization', 'Basic c2lzdGVtYWdlc3Rpb246c2lzZ2VzdGlvbjMyMQ==');
    // }

    return next.handle(req).pipe(
      catchError((err) => {
        let ex = err as HttpErrorResponse;
        if (err.status === 401) {
          return throwError(() => err);
        }
        if ([400, 500].includes(err.status)) {
          if(err.error.errors) {
            console.log(err.error.errors)
          }
          // return throwError(() => err.error);
        }
        if (err.status === 415) {
          // this.message.showWarningMessage("Revisar los campos ingresador en el formulario.");
          console.log(err.status);
        }

        const error = ((err.error != null ? err.error.length : err.message) > 1 ? err.error : err.message) || err.statusText;
        console.log(error);
        return throwError(() => error);
      })
    );
  }
}
